import Interactive from "./interactive";

export default Interactive;